<template>
  <div>
    <div class="filter">
      <div class="row">
        <div class="col-12 text-center p-2">
          <span class="text-muted">
                Kopā atrasti <strong>{{total_count}}</strong> ieraksti
          </span>
        </div>
      </div>
    </div>
    <div class="results">
      <div class="loader" v-if="loading">
        <img src="/images/loading.svg" alt="Loading">
      </div>
      <table class="table table-responsive-xl table-hover">
        <thead class="bg-primary text-white">
        <tr>
          <th>Numurs</th>
          <th>Datums</th>
          <th>Ieguves veids</th>
          <th>Nodevējs</th>
          <th>Pieņēmējs</th>
          <th>Priekšmeti</th>
          <th>Darbības</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="act in acts" :key="act.id">
          <td><a :href="'/act/'+act.id">{{act.act_number}}</a></td>
          <td>{{normalDate(act.date)}}</td>
          <td><span class="badge badge-primary">{{act.transfer_type}}</span></td>
          <td>{{act.giver}}</td>
          <td>{{act.receiver}}</td>
          <td>{{act.items_count}}</td>
          <td style="min-width: 100px;" class="actions">
            <a class="open" :href="'/act/'+act.id" target="_blank" v-tooltip:top="'Uz aktu'"><span class="material-icons">open_in_new</span></a>
            <a class="delete" v-tooltip:top="'Dzēst aktu'" @click="deleteAct(act.id)"><span class="material-icons">close</span></a>

          </td>
        </tr>
        </tbody>
      </table>
      <div class="pagination" v-if="pagination.show_pagination">
        <div class="pages">
          <div class="page" @click="getActs(1)" v-if="pagination.show_first_page">1</div>
          <div class="delimiter" v-if="pagination.show_first_page_divider">...</div>
          <div class="page" @click="getActs(page)" v-for="page in pagination.prev_pages" :key="page">{{page}}</div>
          <div class="page currentPage"  :key="pagination.current_page">{{pagination.current_page}}</div>
          <div class="page" @click="getActs(page)" v-for="page in pagination.next_pages" :key="page">{{page}}</div>
          <div class="delimiter" v-if="pagination.show_last_page_divider">...</div>
          <div class="page" @click="getActs(pagination.total_page_count)" :key="pagination.total_page_count" v-if="pagination.show_last_page">{{pagination.total_page_count}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props:['list_type'],
  mounted()
  {
    this.getActs();
  },
  data()
  {
    return{
      acts:[],
      loading:false,
      pagination:[],
      items_per_page:30,
    }
  },
  methods:{
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    normalDate(date)
    {
      var d = moment(date).format('DD.MM.YYYY.');
      if(moment(d, 'DD.MM.YYYY.').isValid()) {
        return d;
      }
      else {
        return null;
      }
    },
    deleteAct(act_id)
    {
      var that = this;
      that.$swal.fire({
        title: 'Vai tiešām vēlaties dzēst aktu?',
        text: "Šo darbību nebūs iespējams atsaukt.",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#E53935',
        cancelButtonColor: '#888787',
        confirmButtonText: 'Dzēst',
        cancelButtonText: 'Atcelt'
      }).then((result) => {
        if (result.value) {
          axios.post('/dashboard/errors/delete-act',{
            act_id: act_id,
          }).then(response => {
            if(response.data.status == 'success')
            {
              that.$toast.open(response.data.message);
              that.getActs(that.pagination.current_page)
            }
            if(response.data.status == 'error')
            {
              that.$toast.error(response.data.message);
            }
          })
        }
      });

    },
    getActs(page = 1)
    {
      var that = this;
      that.loading = true;
      axios.post('/dashboard/errors/get-acts',{
        list_type: that.$props.list_type,
        page:page,
        items_per_page: that.items_per_page
      }).then(response => {
        that.acts = response.data.acts;
        that.total_count = response.data.total_count,
        that.loading = false;
        that.pagination = response.data.pagination;
        that.scrollToTop();

      })
    }
  }
}
</script>


<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.filter{
  padding: 20px;
  box-shadow: 0 1px 20px rgb(0 0 0 / 20%);
  margin-bottom: 10px;
}
.open{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
  text-decoration: none;
}
.delete{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
  width: 24px;
  height: 24px;
  background-color: #ddd;
  color: #fff;
  transition: all 0.2s ease-in-out;
  border-radius: 100%;
  text-decoration: none;
  &:hover{
    background: $red;
  }
}
.results{
  position:relative;
  .loader{
    cursor: progress;
    position:absolute;

    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    background:rgba(255,255,255,0.7);
    img{
      width:100px;
      height:100px;
    }

  }
}
.pagination{
  margin-top:20px;
  padding-top:20px;
  border-top:solid 2px #777;
  .pages{
    display:flex;
    margin:auto;
    .page{
      width:32px;
      height:32px;
      margin:0 10px;
      display:flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius:100%;
      font-weight: 700;
      transition: all .2s ease-in-out;
      &:hover{
        background:$blue;
        color:#fff;
      }
    }
    .delimiter{
      width:20px;
      height:32px;
      margin:0 0px;
      display:flex;
      color:#333;
      align-items: center;
      justify-content: center;
    }
    .currentPage{
      background:$blue;
      color:#fff;
      cursor:auto;
    }

  }
}
</style>